import { LOCAL_STORAGE_KEYS, LocalStorage } from "@swiggy-private/core-ui";

const isFKCoinsCommsLimitReached = (count: string | null) => {
    return count && Number(count) >= 1;
};

export const showFKCoinsTootip = (isCart: boolean) => {
    const storageKey = isCart
        ? LOCAL_STORAGE_KEYS.FK_COINS_ELIGIBLE_CART_COMMS_IMPRESSION_COUNT
        : LOCAL_STORAGE_KEYS.FK_COINS_ELIGIBLE_PAYMENT_COMMS_IMPRESSION_COUNT;
    const fkCoinsEligibleCommsShownCount = LocalStorage.getItem(storageKey) as string | null;
    return !isFKCoinsCommsLimitReached(fkCoinsEligibleCommsShownCount);
};

export const increaseFKCoinsTooltipShownCounter = (isCart: boolean) => {
    const storageKey = isCart
        ? LOCAL_STORAGE_KEYS.FK_COINS_ELIGIBLE_CART_COMMS_IMPRESSION_COUNT
        : LOCAL_STORAGE_KEYS.FK_COINS_ELIGIBLE_PAYMENT_COMMS_IMPRESSION_COUNT;
    const fkCoinsEligibleCommsShownCount = LocalStorage.getItem(storageKey) as string | null;
    const updatedCount = Number(fkCoinsEligibleCommsShownCount || 0) + 1;
    LocalStorage.setItem(storageKey, updatedCount);
};
